import {List, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import SteddiContainer from "../../General/SteddiContainer";
import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import {CalendarDays, LineChart, Minus, Plus, Scroll} from "lucide-react";
import DynamicListItem from "../../General/DynamicListItem";
import SectionHeader from "../../General/SectionHeader";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import useOrderState from "../../../stores/orderStore";

export default function CancelSaldo() {
  const orderState = useOrderState((state) => state)

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 xs={12}>
          <SteddiContainer padding="sm" background={"tertiary"}>
            <SteddiInfoItem icon={<LineChart/>} bgColor={"secondary"}
                            title={"Din saldo"}
                            subtitle={<Typography sx={{fontSize: "24px", fontWeight: "bold", letterSpacing: 2, mb: -0.5}}>{(orderState.account?.currentBalance ?? 0).toLocaleString()} KR</Typography>}/>
          </SteddiContainer>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer>
            <SectionHeader>Hva betyr det for meg</SectionHeader>
            <List sx={{pb: 0}} className="no-left-pad-list">
              <DynamicListItem>
                <ListItemAvatar>
                  <Minus/>
                </ListItemAvatar>
                <ListItemText>
                  Hvis det står minus foran saldoen din må du betale dette beløpet når du mottar opphørsfaktura.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <Plus/>
                </ListItemAvatar>
                <ListItemText>
                  Hvis saldoen din er positiv får du det beløpet utbetalt til deg. Utbetaling skjer 14 dager etter mottatt opphørsfaktura.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <CalendarDays/>
                </ListItemAvatar>
                <ListItemText>
                  Opphørsfaktura mottar du første virkedag i neste måned.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <Scroll/>
                </ListItemAvatar>
                <ListItemText>
                  Opphørsfaktura består av saldooppgjør, og eventuelle ufakturerte transaksjoner for strøm og nettleie.
                </ListItemText>
              </DynamicListItem>
              <DynamicListItem>
                <ListItemAvatar>
                  <LineChart/>
                </ListItemAvatar>
                <ListItemText>
                  Transaksjoner som innbetalinger fra deg eller strømfaktura fra strømselskap som skjer etter i dag kan påvirke saldoen din. Du kan derfor få et annet beløp på din opphørsfaktura enn det du ser her.
                </ListItemText>
              </DynamicListItem>
            </List>
          </SteddiContainer>
        </Grid2>

      </Grid2>
    </>
  )
}